<template lang="pug">
div(class="xl12 l12 m12 s12 insety-16 border-bottom")
    div(class="before-8")
        label(class="bold bond-title fg70") {{ $t('country_issuer') }}
    div(class="xl12 l12 m12 s12 flex-flex after-16")
        div(class="matdate cr-date")
            label(class="fg50 fs7 insety-8") {{ $t('country_of_issuer') }}
            ib-dropdown(
                name="issuercountry",
                v-model="issuer.value",
                width="25ch",
                :data="availCountries",
                @change="showIssuer"
            )
</template>

<script>
    import mxGb from '../mixin/mixin-global'
    import { countries } from '../js/countries.js'
    export default {
        name: 'CountrySelector',

        props: {
            isNonUS: {
                type: Boolean,
                default: false
            }
        },

        mixins: [ mxGb ],

        data() {
            return {
                countries: countries(this),
                issuer: { label: this.$t('all'), value: '' }
            }
        },

       computed: {
            availCountries() {
                if (this.isNonUS) {
                    return this.countries.filter(e => e.value !== 'US');
                }
                return this.countries;
            }
        },

        methods: {
            reset() {
                this.issuer = { label: this.$t('all'), value: '' };
                this.$emit('issuerCountry', this.issuer);
            },
            showIssuer() {
                const curIssuer = this.countries.filter(country => country.value === this.issuer.value);
                this.$emit('issuerCountry', curIssuer[0]);
            }
        },

        mounted() {
            this.$nextTick(() => {
                if (this.subFilters) {
                    const issuerCountryIs = this.getFilterValue('issuerCountryIs') || '';
                    if (issuerCountryIs) {
                        this.issuer = this.countries.find(country => country.value === issuerCountryIs);
                    }
                    this.showIssuer();
                }
            });
        }
    }
</script>